<template>
    <v-app>
        <v-main>
            <section class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <div class="card">
                                <div class="card-header">
                                    <h3 class="card-title">Daftar Pengeluaran</h3>
                                    <div class="card-tools"></div>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <v-dialog 
                                                ref="dialog" 
                                                v-model="modaltgl"
                                                :return-value.sync="tanggal_query" 
                                                persistent 
                                                width="290px"
                                            >
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-text-field
                                                        v-model="tanggal_query"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        label="Bulan Permintaan Perubahan" 
                                                        outlined
                                                        dense 
                                                        return-object 
                                                        class="w-100"
                                                        append-icon="mdi-calendar" 
                                                    ></v-text-field>
                                                </template>
                                                <v-date-picker 
                                                    v-model="tanggal_query" 
                                                    type="month" 
                                                    scrollable
                                                    min="2022-08" 
                                                    :max="dateMax"
                                                >
                                                    <v-btn text color="primary" @click="modaltgl = false">Cancel</v-btn>
                                                    <v-btn text color="primary" @click="ubahTanggalTampil($refs)">OK</v-btn>
                                                </v-date-picker>
                                            </v-dialog>
                                        </div>

                                        <div class="col-md-6 gap-2 d-flex justify-content-start" style="margin-top: 1px;">
                                            <download-excel 
                                                :data="datas" 
                                                :fields="json_fields"
                                                :worksheet="'Pengeluaran ' + getBulan(tanggal_query)"
                                                :name="'Pengeluaran ' + getBulan(tanggal_query) + '.xls'"
                                            >
                                                <button style="margin-right: 5px;" type="button" class="btn btn-info" data-toggle="modal" data-target="#modal-default">
                                                    <i class="fa fa-file-excel"></i> Download XLS
                                                </button>
                                            </download-excel>

                                            <download-excel 
                                                :data="datas" 
                                                :fields="json_fields" 
                                                type="csv"
                                                :escapeCsv="false"
                                                :worksheet="'Pengeluaran ' + getBulan(tanggal_query)"
                                                :name="'Pengeluaran ' + getBulan(tanggal_query) + '.csv'"
                                            >
                                                <button type="button" class="btn bg-gray">
                                                    <i class="fa fa-file-csv"></i> Download CSV
                                                </button>
                                            </download-excel>
                                        </div>
                                    </div>
                                    <v-text-field
                                        v-model="cari_dt_plg"
                                        label="Cari"
                                        class="w-100 col-md-2 ml-auto mb-2"
                                        outlined
                                        dense
                                        hide-details>
                                    </v-text-field>
                                    <v-data-table 
                                        :headers="headers"
                                        :footer-props="{ itemsPerPageOptions: [10, 25, 50, 100, -1] }"
                                        :items="datas" :items-per-page="25" item-key="id" sort-by="noRows"
                                        class="elevation-1 " show-group-by :search="cari_dt_plg">
                                        <template v-slot:item.noRows="{ item }">
                                            {{ datas.indexOf(item) + 1 }}
                                        </template>
                                        <template v-slot:item.created_at="{ item }">
                                            <div class="text-start">
                                                {{ 
                                                    item.created_at | indoDate
                                                }}
                                                </div>
                                        </template>
                                        <template v-slot:item.jumlah="{ item }">
                                            <div class="text-right font-weight-bold">
                                                {{ 
                                                    item.jumlah | toCurrency
                                                }}
                                                </div>
                                        </template>
                                        <template v-slot:item.actions="{ item }">
                                            <a 
                                                    v-if="item.url_bukti && item.url_bukti !== ''" 
                                                    class="btn btn-xs btn-info" 
                                                    :href="'./storage/' + item.url_bukti" 
                                                    target="_blank" 
                                                    title="Download Bukti" 
                                                >
                                                    <i class="fas fa-download text-white"></i>
                                            </a>
                                            <button  v-else
                                                    class="btn btn-xs btn-warning" 
                                                    @click="uploadModal(item.id)"
                                                    title="Upload Bukti" 
                                                >
                                                    <i class="fas fa-upload text-white"></i>
                                            </button>
                                        </template>
                                        <template v-slot:body.append>
                                            <tr>
                                                <td colspan="4" class="text-right"><strong>Total</strong></td>
                                                <td class="text-right font-weight-bold">{{ jumlahnya | toCurrency }}</td>
                                            </tr>
                                        </template>
                                        <template v-slot:no-data>
                                            <h6>Data Tidak Ditemukan</h6>
                                        </template>
                                    </v-data-table>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Modal -->
                    <div class="modal fade" id="uploadBukti" tabindex="-1" role="dialog" aria-labelledby="uploadBukti" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Upload Bukti Pengeluaran</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <form @submit.prevent="uploadFile()" enctype="multipart/form-data">
                                    <div class="modal-body">
                                        <div class="form-group">
                                            <label>Upload Bukti</label>
                                            <div class="custom-file">
                                                <input type="file" 
                                                    id="file" 
                                                    name="file" 
                                                    class="custom-file-input"
                                                    @change="onUploadKTP" 
                                                    :class="{ 'is-invalid': adaeror['file'] }"
                                                    accept="image/*,.pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                                <label class="custom-file-label" for="file">
                                                    {{ filename ? filename : 'Choose File' }}
                                                </label>
                                                <small v-if="adaeror['file']" class="text-danger">
                                                    {{ adaeror["file"].join(', ') }}
                                                </small>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                        <button type="submit" class="btn btn-primary">Upload!</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <!-- Modal -->
                    <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Tambah Pengeluaran</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                
                                <form @submit.prevent="createData()" enctype="multipart/form-data">
                                    <div class="modal-body">
                                        
                                        <!-- Kas Kantor -->
                                        <div class="form-group">
                                            <label>Kas Kantor</label>
                                            <select name="kantor_id" v-model="form.kantor_id" id="kantor_id" class="form-control" :class="{ 'is-invalid': adaeror['kantor_id'] }" required>
                                                <option value="" selected disabled>-- PILIH KANTOR --</option>
                                                <option v-for="row in kantor_list" :key="row.id" 
                                                    :value="{ id: row.id, text: row.value, saldo: row.saldo_akhir.saldo, maksimal: parseInt(row.saldo_akhir.saldo - (parseInt(row.saldo_akhir.saldo * 10 / 100))) }" 
                                                    :selected="row.id == form.kantor_id.id">
                                                    {{ row.value }}
                                                </option>
                                            </select>
                                            <small v-if="adaeror['kantor_id']" class="text-danger">{{ adaeror["kantor_id"].join(', ') }}</small>
                                        </div>
                                        
                                        <!-- Jumlah & Maksimal Penarikan -->
                                        <div class="form-group">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <label>Jumlah</label>
                                                    <input type="number" @keydown="preventArrow($event)" v-model="form.jumlah" name="jumlah" class="form-control" :class="{ 'is-invalid': adaeror['jumlah'] }" required>
                                                    <small v-if="adaeror['jumlah']" class="text-danger">{{ adaeror["jumlah"].join(', ') }}</small>
                                                </div>
                                                <div class="col-md-6">
                                                    <label>Maksimal Penarikan</label>
                                                    <input type="text" v-model="form.kantor_id.maksimal" name="maksimal" class="form-control" :class="{ 'is-invalid': adaeror['maksimal'] }" disabled>
                                                    <small>Maksimal 10% dari <strong>{{ form.kantor_id.saldo ? form.kantor_id.saldo : 0 | toCurrency}}</strong></small>
                                                    <small v-if="adaeror['maksimal']" class="text-danger">{{ adaeror["maksimal"].join(', ') }}</small>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <!-- Kategori Pengeluaran -->
                                        <div class="form-group">
                                            <label>Kategori Pengeluaran</label>
                                            <select name="kategori" v-model="form.kategori" id="kategori" class="form-control" :class="{ 'is-invalid': adaeror['kategori'] }" required>
                                                <option value="" selected disabled>-- PILIH KATEGORI PENGELUARAN --</option>
                                                <option v-for="row in kategori_list" :key="row.id" :value="{ id: row.id, text: row.value }" :selected="row.id == form.kategori.id">{{ row.value }}</option>
                                            </select>
                                            <small v-if="adaeror['kategori']" class="text-danger">{{ adaeror["kategori"].join(', ') }}</small>
                                        </div>
                                        
                                        <!-- Keterangan -->
                                        <div class="form-group">
                                            <label>Keterangan</label>
                                            <textarea v-model="form.keterangan" id="keterangan" name="keterangan" style="resize:none" rows="5" class="form-control" :class="{ 'is-invalid': adaeror['keterangan'] }" required></textarea>
                                            <small v-if="adaeror['keterangan']" class="text-danger">{{ adaeror["keterangan"].join(', ') }}</small>
                                        </div>
                                        
                                        <!-- Upload Bukti -->
                                        <div class="form-group">
                                            <label>Upload Bukti</label>
                                            <div class="custom-file">
                                                <input type="file" id="file" name="file" class="custom-file-input" @change="onUploadKTP" :class="{ 'is-invalid': adaeror['file'] }" accept="image/*,.pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel">
                                                <label class="custom-file-label" for="file">{{ filename ? filename : 'Choose File'}}</label>
                                                <small v-if="adaeror['file']" class="text-danger">{{ adaeror["file"].join(', ') }}</small>
                                            </div>
                                        </div>
                                        
                                        <!-- Pejabat Approval -->
                                        <div class="form-group">
                                            <label>Pejabat Approval</label>
                                            <div class="form-check" v-for="row in pejabat_list">
                                                <input type="checkbox" v-model="form.pejabat_approval" :id="'ch' + row.id" :value="row.id" :name="'ch' + row.id" class="form-check-input">
                                                <label :for="'ch' + row.id" class="form-check-label">{{ row.name }}</label>
                                            </div>
                                            <div v-if="!pejabat_list.length">
                                                <span class="text-red">Gagal Mengambil Pejabat Approval</span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                                        <button type="submit" class="btn btn-primary">Tambah!</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>


                    <div class="modal fade" id="KeteranganModal" tabindex="-1" role="dialog" 
                        aria-labelledby="KeteranganModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Keterangan Pengeluaran</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" 
                                        @click="closeKeteranganModal()">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <div class="row">
                                        <div class="col-md-12">
                                            {{ tampilKet }}
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal" 
                                        @click="closeKeteranganModal()">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </v-main>
    </v-app>
</template>

<script>
    export default {
        data() {
            return {
                datas: [],
                form: new Form({
                    jumlah: '',
                    kategori: '',
                    keterangan: '',
                    kantor_id: '',
                    pejabat_approval: [],
                }),
                data2: new Form({
                    keuangan_id: '',
                }),
                kategori_list: [],
                kantor_list: [],
                pejabat_list: [],
                filename: '',
                urlFotoKtp: '',
                file: '',
                urlFotoKtpPreview: false,
                adaeror: [],
                menu: false,
                tampilKet: '',
                modaltgl: false,
                dateMax: new Date().toISOString().substr(0, 7),
                tanggal_query: new Date().toISOString().substr(0, 7),
                tanggal_tampil: '',
                jumlahnya: 0,
                json_fields: {
                    "TANGGAL": {
                        field: "created_at",
                        callback: (value) => {
                            return this.getTanggalIndo(value);
                        },
                    },
                    "NAMA KATEGORI": "kategori_keuangan.value",
                    "KAS KANTOR": "keuangan_kantor.value",
                    "JUMLAH": "jumlah",
                    "KETERANGAN": "keterangan",
                    "PEJABAT": {
                        field: "keuangan_permintaan.pejabat_approval_permintaan",
                        callback: (value) => {
                            return this.getPejabatList(value);
                        },
                    },
                },
                cari_dt_plg: '',
                headers: [
                    { text: 'No', value: 'noRows', sortable: true, groupable: false, },
                    { text: 'Tanggal Dibuat', value: 'created_at', groupable: false, },
                    { text: 'Ket', value: 'keterangan', groupable: false, },
                    { text: 'Kategori', value: 'kategori_keuangan.value', groupable: false, },
                    { text: 'Jumlah', value: 'jumlah', groupable: false, },
                    { text: 'User', value: 'user.name', groupable: false,},
                    { text: 'Aksi', value: 'actions', sortable: false, groupable: false, align: "center", class: "text-right" },
                ],
            }
        },

        methods: {
            getPejabatList(namanama) {
                return Array.prototype.map.call(namanama, function (item) { return item.name; }).join("; ");
            },

            countJumlahnya() {
                Object.entries(this.datas).forEach(([key, val]) => { this.jumlahnya += parseFloat(val.jumlah) });
            },

            getBulan(tanggal) {
                var tgltemp = new Date(tanggal);
                var tahun = tgltemp.getFullYear();
                var bulan = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
                return (bulan[tgltemp.getMonth()] + " " + tahun);
            },

            getTanggalIndo(tanggal) {
                var tgltemp = new Date(tanggal);
                var tahun = tgltemp.getFullYear();
                var bulan = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];

                return (tgltemp.getDate() + "/" + bulan[tgltemp.getMonth()] + "/" + tahun);
            },

            ubahTanggalTampil(e) {
                e.dialog.save(this.tanggal_query);
                this.loadData();
            },

            bukaKeteranganModal(id) {
                this.tampilKet = id;
                $('#KeteranganModal').modal('show');
            },

            closeKeteranganModal() {
                this.tampilKet = '';
                $('#KeteranganModal').modal('hide');
            },

            onUploadKTP(e) {
                this.filename = e.target.files[0].name;
                this.file = e.target.files[0];
                if (this.file) {
                    /*
                        Ensure the file is an image file.
                    */
                    if (/\.(jpe?g|png|gif|pdf|xls|xlsx|csv|odt)$/i.test(this.filename)) {

                        /*
                        Fire the readAsDataURL method which will read the file in and
                        upon completion fire a 'load' event which we will listen to and
                        display the image in the preview.
                        */
                        // reader.readAsDataURL( this.form.file );
                    } else {
                        this.filename = "ERROR! Hanya PDF atau Image(JPEG/JPG/PNG) atau Excel (XLS/XLSX/ODT/CSV)";
                        this.file = "";
                    }
                } else {
                    this.filename = "";
                    this.file = "";
                }
            },

            getResults(page = 1) {
                this.$Progress.start();
                axios.get('api/keuangan/pengeluaran?page=' + page).then(({ data }) => (this.datas = data.data));
                this.$Progress.finish();
            },

            loadKantor() {
                axios.get("api/kantor").then(({ data }) => (this.kantor_list = data.data.data));
            },

            loadKategori() {
                axios.get("api/keuangan/kategori_list?q=" + escape(2)).then(({ data }) => (this.kategori_list = data.data));
            },

            loadPejabatApproval() {
                axios.get("api/keuangan/pejabat_list").then(({ data }) => (this.pejabat_list = data.data));
            },

            // 
            loadData() {
                if (this.$gate.isAllowed("is_keuangan")) {
                   
                    this.jumlahnya = 0;
                    let tahunpaid = this.tanggal_query.substr(0, 4);
                    let bulanpaid = this.tanggal_query.substr(-2, 2);
                    axios.get("api/keuangan/pengeluaran?tahunpaid=" + tahunpaid + "&bulanpaid=" + bulanpaid).then(({ data }) => {
                       
                        if (data.data.length) {
                            this.datas = data.data;
                            this.countJumlahnya();
                        } else {
                            this.datas = [];
                        }
                    });

                    this.tanggal_tampil = this.getBulan(this.tanggal_query);
                }
                console.log(this.datas)
            },

            uploadModal(id) {
                this.adaeror = [];
                this.filename = "";
                this.file = "";
                this.data2.keuangan_id = id;
                $('#uploadBukti').modal('show');
            },

            newModal() {
                this.form.reset();
                this.adaeror = [];
                this.loadKategori();
                this.loadKantor();
                this.loadPejabatApproval();
                this.filename = "";
                this.file = "";
                $('#addNew').modal('show');
            },

            uploadFile() {
                this.$Progress.start();
                const config = {
                    headers: {
                        'content-type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
                    }
                }
                let formData = new FormData();
                formData.append('file', this.file);
                formData.append('datanya', JSON.stringify(this.data2));
                axios.post('api/keuangan/addBuktiPengeluaran', formData, config)
                    .then((data) => {
                        if (data.data.success) {
                            $('#uploadBukti').modal('hide');

                            Toast.fire({
                                icon: 'success',
                                title: data.data.message
                            });
                            this.$Progress.finish();
                            this.loadData();
                            this.adaeror = [];
                            this.filename = "";
                            this.file = "";
                            this.data2.keuangan_id = "";
                        } else {
                            Toast.fire({
                                icon: 'error',
                                title: 'Some error occured! Please try again'
                            });

                            this.$Progress.fail();
                        }
                    })
                    .catch(e => {
                        this.adaeror = e.response.data.errors;
                        this.$Progress.fail();
                        Toast.fire({
                            icon: 'error',
                            title: 'Some error occured! Please try again'
                        });
                    })
            },

            createData() {
                this.$Progress.start();
                if (this.file) {
                    if (this.form.pejabat_approval.length > 0) {
                        const config = {
                            headers: {
                                'content-type': 'multipart/form-data; charset=utf-8; boundary=' + Math.random().toString().substr(2)
                            }
                        }
                        let formData = new FormData();
                        formData.append('file', this.file);
                        formData.append('datanya', JSON.stringify(this.form));
                        axios.post('api/keuangan/addPermintaanPengeluaran', formData, config)
                            .then((data) => {
                                if (data.data.success) {
                                    $('#addNew').modal('hide');

                                    Toast.fire({
                                        icon: 'success',
                                        title: data.data.message
                                    });
                                    this.$Progress.finish();
                                    this.loadData();
                                    this.adaeror = [];
                                    this.filename = "";
                                    this.file = "";
                                } else {
                                    Toast.fire({
                                        icon: 'error',
                                        title: 'Some error occured! Please try again'
                                    });

                                    this.$Progress.fail();
                                }
                            })
                            .catch(e => {
                                this.adaeror = e.response.data.errors;
                                this.$Progress.fail();
                                Toast.fire({
                                    icon: 'error',
                                    title: 'Some error occured! Please try again'
                                });
                            })
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: 'Pejabat Approval Harus Dipilih'
                        });

                        this.$Progress.fail();
                    }
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: 'Bukti Wajib Diupload'
                    });

                    this.$Progress.fail();

                }
            },

            deleteData(id) {
                Swal.fire({
                    title: 'Yakin untuk menghapus?',
                    text: "Data yang sudah diApproved tidak dapat dihapus.",
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Ya, Hapus!'
                }).then((result) => {

                    if (result.value) {
                        this.form.delete('api/router/' + id).then(() => {
                            Swal.fire(
                                'Terhapus!',
                                'Data Pengeluaran Berhasil Dihapus.',
                                'success'
                            );
                            this.loadData();
                        }).catch((data) => {
                            Swal.fire("Hapus Gagal!", data.message, "warning");
                        });
                    }
                })
            },

            preventArrow(e) {
                if (e.which === 38 || e.which === 40) {
                    e.preventDefault();
                }
                if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
                    e.preventDefault();
                }
            },
        },

        // computed: {
        //     jumlahnya() {
        //         return this.datas.reduce((acc, item) => acc + Number(item.jumlah), 0);
        //     }
        // },

        created() {
            this.$Progress.start();
            this.loadData();
            this.$Progress.finish();
        }
    }
</script>

<style scoped>
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>